<template>
  <div>
    <div v-for="(element, key) in careerLanguageElements" :key="key">
      <a :href="element.href" target="_blank"><div class="title">
        <h1>{{ element.name }}</h1>
      </div></a>
      <div v-for="(step, key) in element.steps" :key="key">
        <career-element-step :step="step" />
      </div>
    </div>
  </div>
</template>

<script>
import CareerElementStep from "./CareerElementStep";
import {mapState, mapGetters} from "vuex";

export default {
  name: "CareerSteps",
  components: {
    CareerElementStep
  },
  computed: {
    ...mapState([
      "careerElements"
    ]),
    ...mapGetters([
        "careerLanguageElements"
    ])
  }
}
</script>

<style scoped>
.title {
  text-decoration: underline;
  margin-bottom: 30px;
}
</style>